/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Component, Input } from '@angular/core';
import { SimpleChartData } from '@app/app/shared/components/carts/SimpleChartData';

@Component({
  selector: 'ptl-simple-horizontal-bar-chart',
  templateUrl: './simple-horizontal-bar-chart.component.html',
  styleUrls: ['./simple-horizontal-bar-chart.component.scss'],
})
export class SimpleHorizontalBarChartComponent {
  @Input() chartData: SimpleChartData[];
}
